module.exports = __webpack_public_path__ + "img/18.82bbfa6e.jpg";